import { useMemo } from 'react';

import {
  type CATEGORY_TYPE,
  CategoryDic,
  OrderedCategoryList,
} from '@/types/categoryConst';

import useColor from './useColor';

const useCategoryMap = (): Record<CATEGORY_TYPE, ClassificationItemT> => {
  const color = useColor();
  const categoryMap: Record<CATEGORY_TYPE, ClassificationItemT> =
    useMemo(() => {
      return OrderedCategoryList.reduce(
        (acc, category) => {
          acc[category] = {
            id: category,
            color: color.profile[category],
            name: CategoryDic[category],
          };
          return acc;
        },
        {} as Record<CATEGORY_TYPE, ClassificationItemT>,
      );
    }, [color.profile]);

  return categoryMap;
};

export default useCategoryMap;
